import React, { useState } from 'react';
import {
  Dialog,
  DialogContent,
  Typography,
  Button,
  DialogContentText,
  Box,
  IconButton,
} from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

type TShowReleaseNoteProps = {
  open: boolean;
  onClose: () => void;
};

const PastPapersReleaseNote: React.FC<TShowReleaseNoteProps> = ({
  open,
  onClose,
}) => {
  const [currentPage, setCurrentPage] = useState(1);

  const handleNext = () => {
    setCurrentPage(2);
  };

  const handlePrevious = () => {
    setCurrentPage(1);
  };

  const handleClose = () => {
    setCurrentPage(1);
    onClose();
  };

  return (
    <Dialog
      PaperProps={{ sx: { borderRadius: '15px', maxWidth: '400px' } }}
      open={open}
    >
      <DialogContent
        sx={{ textAlign: 'center', position: 'relative', pb: '80px' }}
      >
        {currentPage === 1 && (
          <>
            <img
              src={`${process.env.PUBLIC_URL}/images/pastPaperPage/releaseNote/header1.png`}
              alt="header"
              style={{ width: '100%', height: '20%' }}
            />

            <DialogContent sx={{ fontWeight: 'bold', fontSize: '14px' }}>
              New Update: Topical Past Paper 📚
            </DialogContent>
            <Typography sx={{ fontSize: '13px' }}>
              We’ve added topical past papers to help you practice and stay
              ahead. Focus on what matters and build your confidence for the big
              day!
            </Typography>
            <DialogContentText
              sx={{ fontWeight: 'bold', fontSize: '11px', mt: 2 }}
            >
              Select Cambridge IGCSE ➞ Select Subject ➞ Access Topical Past
              Paper Questions
            </DialogContentText>
          </>
        )}

        {currentPage === 2 && (
          <>
            <img
              src={`${process.env.PUBLIC_URL}/images/pastPaperPage/releaseNote/header2.png`}
              alt="header"
              style={{ width: '100%', height: '20%' }}
            />

            <DialogContent sx={{ fontWeight: 'bold', fontSize: '14px' }}>
              New Update: Past Papers Now Available! 📚
            </DialogContent>
            <Typography sx={{ fontSize: '13px' }}>
              We’ve added past exam papers with marking schemes to help you
              prepare better and ace your exams!
            </Typography>
            <DialogContentText
              sx={{ fontWeight: 'bold', fontSize: '11px', mt: 2 }}
            >
              Choose your curriculum ➞ Select Subject ➞ Access Past Paper
            </DialogContentText>
          </>
        )}

        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            position: 'absolute',
            bottom: 25,
            left: 25,
            right: 25,
          }}
        >
          <Box>
            {currentPage === 2 && (
              <IconButton
                onClick={handlePrevious}
                sx={{
                  fontSize: '12px',
                  color: '#94A3B8',
                  fontWeight: 'bold',
                  '&:hover': { backgroundColor: 'transparent' },
                }}
              >
                <ArrowBackIcon
                  fontSize="small"
                  style={{ marginRight: '10px' }}
                />
                2 of 2 features
              </IconButton>
            )}
            {currentPage === 1 && (
              <Typography
                sx={{ fontSize: '12px', color: '#94A3B8', fontWeight: 'bold' }}
              >
                1 of 2 features
              </Typography>
            )}
          </Box>

          <Box>
            {currentPage === 1 && (
              <Button
                variant="contained"
                sx={{
                  backgroundColor: '#1E293B',
                  color: 'white',
                  fontSize: '12px',
                  pl: 4,
                  pr: 4,
                  '&:hover': {
                    backgroundColor: '#787878',
                  },
                }}
                onClick={handleNext}
              >
                Next
              </Button>
            )}
            {currentPage === 2 && (
              <Button
                variant="contained"
                sx={{
                  backgroundColor: '#1E293B',
                  color: 'white',
                  fontSize: '12px',
                  pl: 4,
                  pr: 4,
                  '&:hover': {
                    backgroundColor: '#787878',
                  },
                }}
                onClick={handleClose}
              >
                Got it
              </Button>
            )}
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default PastPapersReleaseNote;
